import { escapeHtml } from '../utils';
import { codexNativeProviderMissing, type CodexProviderSettingsState } from './codex-provider-settings-model';

type RenderCodexProviderSettingsArgs = {
  container: Element;
  state: CodexProviderSettingsState;
  codexConfig: any;
  templates: Array<{ name: string }>;
};

export function renderCodexProviderSettings(args: RenderCodexProviderSettingsArgs): void {
  const { container, state, codexConfig, templates } = args;
  const nativeProviders = Array.isArray(codexConfig?.nativeProviders) ? codexConfig.nativeProviders : [];
  const defaultProvider = String(codexConfig?.nativeDefaultProvider || '').trim();
  const nativeOptions = nativeProviders.map((provider) =>
    `<option value="${escapeHtml(provider)}" ${provider === state.nativeProvider ? 'selected' : ''}>${escapeHtml(provider)}</option>`
  ).join('');
  const missingNative = codexNativeProviderMissing(state.nativeProvider, nativeProviders);
  const templateOptions = templates.map((template) =>
    `<option value="${escapeHtml(template.name)}" ${template.name === state.templateProvider ? 'selected' : ''}>${escapeHtml(template.name)}</option>`
  ).join('');

  // 原生 Provider 和 Webcoding 模板是两套来源，分标签页可避免把本机配置和模板配置混成一个下拉语义。
  container.innerHTML = `
    <div class="settings-inline-tabs">
      <button type="button" class="settings-inline-tab" data-codex-tab="native" ${state.activeTab === 'native' ? 'data-active="1"' : ''}>原生 Provider</button>
      <button type="button" class="settings-inline-tab" data-codex-tab="template" ${state.activeTab === 'template' ? 'data-active="1"' : ''}>Webcoding 模板</button>
    </div>
    ${state.activeTab === 'native' ? `
      <select class="settings-select" id="unified-codex-native-provider">
        <option value="">跟随本机默认${defaultProvider ? `（${escapeHtml(defaultProvider)}）` : ''}</option>
        ${nativeOptions}
        ${missingNative ? `<option value="${escapeHtml(state.nativeProvider)}" selected>${escapeHtml(state.nativeProvider)}（当前本机配置不存在）</option>` : ''}
      </select>
      ${missingNative ? '<div class="settings-inline-note warning">已保存但当前本机配置不存在；可改回跟随默认或选择其他 Provider。</div>' : ''}
    ` : `
      <select class="settings-select" id="unified-codex-template-provider">
        ${templateOptions || '<option value="">暂无 Webcoding 模板</option>'}
      </select>
    `}
  `;

  container.querySelectorAll('[data-codex-tab]').forEach((button) => {
    button.addEventListener('click', () => {
      state.activeTab = button instanceof HTMLElement && button.dataset.codexTab === 'template' ? 'template' : 'native';
      renderCodexProviderSettings(args);
    });
  });
  container.querySelector('#unified-codex-native-provider')?.addEventListener('change', (event) => {
    state.nativeProvider = event.target instanceof HTMLSelectElement ? event.target.value : '';
  });
  container.querySelector('#unified-codex-template-provider')?.addEventListener('change', (event) => {
    state.templateProvider = event.target instanceof HTMLSelectElement ? event.target.value : '';
  });
}
